/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PROGRESS BAR
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	progressbar: {
		borderRadius: pxToEm(13),
		height: pxToEm(12),
		width: '100%',
		position: 'relative',
		'& .bar': {
			borderRadius: 'inherit',
			width: '100%',
			height: '100%',
			position: 'absolute',
			top: '0',
			left: '0',
			'&.foreground': {
				zIndex: '2'
			},
			'&.background': {
				background: '#F5F5F5',
				zIndex: '1'
			}
		}
	}
});